import { createElement } from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { flowRight } from 'lodash';
import { store } from '../store';
import { ComponentDesc } from '../store';
import withStyles, { WithStyles } from 'react-jss';
import { SketchPicker } from 'react-color';
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import reactCSS from 'reactcss';
import { ChromePicker } from 'react-color';
import { settingsPanelStyles as styles } from './styles';
import { props } from 'cypress/types/bluebird';
import ReactTooltip from 'react-tooltip';

const color_picker = require('../components/icons/color_picker.svg');
//import { settingsPanelStyles as styles } from "../components/common/styles";

interface IProps extends WithStyles<typeof styles> {
    descriptor: ComponentDesc<any>;
}

const styles = {
    root: {
        //paddingLeft: 5,
        padding: 10,
        //margin: 10,
        height: 'auto',
        backgroundColor: '#F2F2F5',
        color: '#a0aabf',
        borderBottom: '1px solid #CDCED1',
    },
    subroot: {
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: 15,
        align: 'center',
    },
    item: {
        flexBasis: '50%',
    },
    header: {
        color: '#2F343E',
        fontSize: 12,
    },
    input: {
        width: 60,
        height: 25,
        textAlign: 'center',
        borderRadius: 5,
        backgroundColor: '#FFFFFF',
        color: '#A0AAA2',
        border: 'none',
        // marginLeft: 'px',
    },
    inputBox: {
        marginLeft: '20px',
    },
    widthslider: {
        width: 100,
        height: 5,
    },

    title: {
        fontSize: '18px',
        //  marginLeft: '20px',
        margintop: '50px',
        color: '#2F343E',
    },
    icon: {
        color: '#FFBF5B',
    },
    sub_header: {
        color: '#FFBF5B',
        textAlign: 'center',
        fontSize: 12,
    },
    panel: {
        marginBottom: '10px',
        marginTop: '10px',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
};

interface IProps extends WithStyles<typeof styles> {
    type: string;
    row: ComponentDesc<any>;
}

class ComponentsList extends Component<IProps, any> {
    state = {
        displayBackgroundpicker: false,
        displayContentBackgroundpicker: false,
        displayColorPicker: false,
        color: {
            r: '0',
            g: '0',
            b: '0',
        },
        isExpanded: false,
    };

    handlePadding = (abc) => {
        store.selectedRow.settings.padding = +abc.target.value;
    };

    handleOnChangeBackground = (value) => {
        store.selectedRow.settings.backgroundColor = value.hex;
    };
    handleClickBackgroundColor = () => {
        this.setState({
            displayBackgroundpicker: !this.state.displayBackgroundpicker,
        });
    };
    handleCloseBackgroundColor = () => {
        this.setState({ displayBackgroundpicker: false });
    };

    handleClickColor = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker });
    };

    handleCloseColor = () => {
        this.setState({ displayColorPicker: false });
    };

    handleChangeColor = (color) => {
        store.selectedRow.settings.color = color.hex;
    };

    handleOnChangeContentBackground = (value) => {
        store.selectedRow.settings.contentBackgroundColor = value.hex;
    };
    handleClickContentBackgroundColor = () => {
        this.setState({
            displayContentBackgroundpicker: !this.state.displayContentBackgroundpicker,
        });
    };
    handleCloseContentBackgroundColor = () => {
        this.setState({ displayContentBackgroundpicker: false });
    };

    constructor(props, context) {
        super(props, context);
    }
    render() {
        const { classes, row } = this.props;
        let { descriptor } = this.props;

        const styles = reactCSS({
            default: {
                color: {
                    width: '50px',
                    height: '14px',
                    borderRadius: '2px',
                    background: `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b})`,
                },

                swatch: {
                    padding: '5px',
                    background: '#DDDDDD',
                    borderRadius: '1px',
                    boxShadow: '#DDDDDD',
                    display: 'inline-block',
                    cursor: 'pointer',
                    width: 50,
                },
                popover: {
                    position: 'absolute',
                    right: '0',
                    top: '40px',
                    zIndex: 1,
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });
        return (
            <div>
                <div className={classes.subroot}>
                    <span className={classes.title} style={{ paddingLeft: '10px', marginBottom: '10px' }}>
                        Row Settings
                    </span>
                </div>
                <div className={classes.root} style={{ position: 'relative' }}>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '10px',
                        }}>
                        <span className={classes.header} style={{ width: '130px' }}>
                            Padding
                        </span>

                        <input style={{ width: '110px' }} type="number" className={classes.input + ' paddingInputbox'} value={store.selectedRow.settings.padding} onChange={this.handlePadding} />
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '10px',
                            position: 'relative',
                        }}>
                        <span className={classes.header} style={{ width: '130px' }}>
                            Background Color
                        </span>
                        <button
                            style={{
                                backgroundColor: store.selectedRow.settings.backgroundColor,
                                border: '2px solid transparent',
                                width: '30px',
                                height: '30px',
                                borderRadius: '4px',
                                marginRight: '4px',
                            }}
                        />
                        <input className={classes.input} type="text" style={{ width: '75px' }} name="selected_color" value={store.selectedRow.settings.backgroundColor} />
                        <img style={{ marginLeft: '4px' }} src={color_picker} onClick={this.handleClickBackgroundColor} style={{ marginLeft: '15px' }} data-for="color" title="Pick Color" />
                        {this.state.displayBackgroundpicker ? (
                            <div style={styles.popover}>
                                <div style={styles.cover} onClick={this.handleCloseBackgroundColor} />
                                <ChromePicker color={store.selectedRow.settings.backgroundColor} onChange={this.handleOnChangeBackground} />
                            </div>
                        ) : null}
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '10px',
                            position: 'relative',
                        }}>
                        <span className={classes.header} style={{ width: '130px' }}>
                            Color
                        </span>

                        <button
                            style={{
                                backgroundColor: store.selectedRow.settings.color,
                                border: '2px solid transparent',
                                width: '30px',
                                height: '30px',
                                borderRadius: '4px',
                                marginRight: '4px',
                            }}
                        />
                        <input className={classes.input} type="text" style={{ width: '75px' }} name="selected_color" value={store.selectedRow.settings.color} />

                        <img style={{ marginLeft: '4px' }} src={color_picker} onClick={this.handleClickColor} data-for="color" style={{ marginLeft: '15px' }} title="Pick Color" />
                        {this.state.displayColorPicker ? (
                            <div style={styles.popover}>
                                <div style={styles.cover} onClick={this.handleCloseColor} />
                                <ChromePicker color={store.selectedRow.settings.color} onChange={this.handleChangeColor} />
                            </div>
                        ) : null}
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '10px',
                            position: 'relative',
                        }}>
                        <span className={classes.header} style={{ width: '130px' }}>
                            Content Background Color
                        </span>

                        <button
                            style={{
                                backgroundColor: store.selectedRow.settings.contentBackgroundColor,
                                border: '2px solid transparent',
                                width: '30px',
                                height: '30px',
                                borderRadius: '4px',
                                marginRight: '4px',
                            }}
                        />
                        <input className={classes.input} type="text" style={{ width: '75px' }} name="selected_color" value={store.selectedRow.settings.contentBackgroundColor} />

                        <img style={{ marginLeft: '4px' }} src={color_picker} onClick={this.handleClickContentBackgroundColor} data-for="color" style={{ marginLeft: '15px' }} title="Pick Color" />
                        {this.state.displayContentBackgroundpicker ? (
                            <div style={styles.popover}>
                                <div style={styles.cover} onClick={this.handleCloseContentBackgroundColor} />
                                <ChromePicker color={store.selectedRow.settings.contentBackgroundColor} onChange={this.handleOnChangeContentBackground} />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

export default flowRight([withStyles(styles), observer])(ComponentsList);
